import Image from 'next/image';
import Logo from '@/assets/icons/logo.svg';
import { UserAvatarMenu } from './user-avatar-menu';
import { OrganizationSelector } from './organization-selector';
import { useMediaQuery } from '@/hooks/use-media-query';
import { MobileMenu } from '../mobile-menu';
import Link from 'next/link';
import { useOrganizationContext } from '@/contexts/organization-context';
import { AgentTabs } from './agent-tabs';
import { useRouter } from 'next/router';
import { RoutePaths } from '@/consts/routes';

export function Header() {
  const { organizationId } = useOrganizationContext();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isDesktop = !isMobile;
  const router = useRouter();
  const isOnboardingAgentPage = router.pathname.includes(
    RoutePaths.OnboardingAgent
  );

  if (isOnboardingAgentPage) {
    return (
      <div className='flex items-center justify-center'>
        <Link
          href={`/${organizationId ? `?organizationId=${organizationId}` : ''}`}
          className='shrink-0 py-4 md:mx-8'
        >
          <Image src={Logo} alt='Vee' width={68} />
        </Link>
      </div>
    );
  }

  return (
    <div className='mx-8 flex items-center justify-between border-b border-b-slate-100 px-0 pb-0 pt-5'>
      <div className='flex items-end justify-end gap-0 lg:gap-10'>
        <Link
          href={`/${organizationId ? `?organizationId=${organizationId}` : ''}`}
          className='shrink-0 py-4 md:mx-8'
        >
          <Image src={Logo} alt='Vee' width={68} />
        </Link>
        {isDesktop && <AgentTabs />}
      </div>

      {isDesktop && (
        <div className='my-3 basis-1/3'>
          <OrganizationSelector />
        </div>
      )}

      {isDesktop && (
        <div className='flex items-center'>
          <UserAvatarMenu />
        </div>
      )}

      {isMobile && <MobileMenu />}
    </div>
  );
}
